import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirtableBase = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 6,
			fill: "#EEEFF1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4756 11.3359L10.4643 14.6511C10.0188 14.8357 10.0235 15.4683 10.4717 15.6459L18.5162 18.8362C19.223 19.1165 20.0102 19.1165 20.717 18.8362L28.7616 15.6459C29.2098 15.4679 29.2148 14.8354 28.7689 14.6511L20.758 11.3362C20.0271 11.0338 19.2061 11.0338 18.4752 11.3362",
			fill: "#FFCC00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3726 20.3948V28.3644C20.3727 28.452 20.3942 28.5382 20.4352 28.6155C20.4762 28.6928 20.5355 28.759 20.6079 28.8081C20.6804 28.8573 20.7637 28.8881 20.8507 28.8977C20.9377 28.9073 21.0258 28.8955 21.1072 28.8634L30.0716 25.3837C30.1716 25.3439 30.2573 25.2752 30.3176 25.1862C30.378 25.0973 30.4104 24.9923 30.4104 24.8847V16.9154C30.4103 16.8279 30.3888 16.7417 30.3478 16.6644C30.3068 16.587 30.2475 16.5209 30.175 16.4717C30.1026 16.4225 30.0193 16.3918 29.9323 16.3822C29.8453 16.3725 29.7572 16.3843 29.6758 16.4165L20.7113 19.8962C20.6114 19.9359 20.5257 20.0047 20.4653 20.0936C20.4049 20.1826 20.3726 20.2873 20.3726 20.3948Z",
			fill: "#31C2F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2456 20.7727L15.3152 22.1879L9.69917 24.8789C9.34327 25.0508 8.88867 24.7916 8.88867 24.3954V16.9156C8.88867 16.7726 8.96186 16.6491 9.06057 16.5564C9.10092 16.5162 9.14669 16.4818 9.19655 16.4543C9.33085 16.3737 9.52223 16.3523 9.68507 16.4167L18.2013 19.791C18.6378 19.9629 18.6714 20.5693 18.246 20.7731",
			fill: "#ED3049"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.221 20.7734L15.5606 22.058L9.03564 16.5564C9.07599 16.5162 9.12176 16.4818 9.17162 16.4543C9.30592 16.3737 9.4973 16.3523 9.66014 16.4167L18.1764 19.791C18.6129 19.9629 18.6464 20.5696 18.221 20.7734Z",
			fill: "#C62842"
		})
	]
});
export default SvgAirtableBase;
